import React, {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import greenTick from '../../../../media/images/check.svg'
import redCross from '../../../../media/images/ic-close.svg'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import {InfoCard2} from '../../widgets/components/UI/InfoCard2'
import {Quill} from '../../widgets/components/Input/Quill'
import {FileUpload} from '../../widgets/components/FileUpload'
import {allowedRecordTypes} from '../../../core/_constants'
import {ToolTipUIForModal} from '../../widgets/components/UI/ToolTipUIForModal'
import {getFileType} from '../../../core/_util'
import deleteIcon from '../../../../media/stakeholders/ic-delete.svg'
import {DeleteFileConfirmationModal} from '../../compliance-meeting/components/CancelConfimrationModal'
import {getFileRequest, getRecordPublicFileRequest} from '../core/_requests'
import {toast} from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
const RecordKeeperPublicRequest = () => {
  const {formatMessage} = useIntl()
  const location = useLocation()
  const pathname = location.pathname
  const parts = pathname.split('/')
  const [reason, setReason] = useState('')
  const paramValue = parts[parts.length - 1]
  const requestId = parts[parts.length - 2]
  const company = parts[parts.length - 3]
  const [modalStatus, setModalStatus] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [cancelLoading, setCancelLoading] = useState(false)
  const [requestReject, setRequestReject] = useState(false)
  const [requestRejected, setRequestRejected] = useState(false)
  const [requestAccepted, setRequestAccepted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState<any[]>([])
  const [id, setId] = useState<any>()
  const [data, setData] = useState<any>()
  const [requestDetails, setRequestDetails] = useState<any>()
  const [isRequested, setIsRequested] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const handleSubmit = async () => {
    const details = files.map((file) => file.details)
    try {
      setLoading(true)
      const {
        data: {success, error},
      } = await getRecordPublicFileRequest(requestId, {
        files: details,
        reason: reason,
        action: 'UPLOADED',
      })
      if (success) {
        setRequestAccepted(true)
        setRequestReject(true)
        toast.success('File request has been accepted.')
      } else {
        toast.error(error)
      }
    } catch (err: any) {
      toast.error(err.message)
    } finally {
      setLoading(false)
    }
  }
  const onRejectSubmit = async () => {
    try {
      setLoading(true)
      const {
        data: {data, success, error},
      } = await getRecordPublicFileRequest(requestId, {reason: reason, action: 'REJECTED'})
      if (success) {
        setRequestRejected(true)
        setRequestReject(true)
        setData(data)
        toast.success('File request has been rejected.')
      } else {
        toast.error(error)
      }
    } catch (err: any) {
      toast.error(err.message)
    } finally {
      setLoading(false)
    }
  }
  const deleteFile = async () => {
    setCancelLoading(true)
    const isFind = files.find((_, index) => index === id) // Find the file
    if (isFind) {
      setFiles(files.filter((_, index) => index !== id)) // Remove file by index
    }
    setShowCancelModal(false)
    setCancelLoading(false) // Corrected to false
    toast.success(formatMessage({id: 'File removed successfully'}))
  }
  const getRequestedFileData = async (requestedFileId: string) => {
    if (!company) return
    try {
      const {
        data: {success, data},
      } = await getFileRequest(parseInt(company), requestedFileId)
      if (success) {
        if (data.action !== 'REQUESTED') {
          setIsRequested(false)
          toast.error(
            `File request has been ${data.action === 'UPLOADED' ? 'accepted' : 'rejected'}`
          )
        } else {
          setRequestDetails(data)
          setIsRequested(true)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(true)
    }
  }
  useEffect(() => {
    if (!isRequested) {
      getRequestedFileData(requestId)
    }
  }, []) // eslint-disable-line
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'
  const Host = window.location.host
  const protocol = window.location.protocol
  const registrationUrl = Host.includes('localhost')
    ? `/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-requests`
    : `${protocol}//${Host}/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-requests`
  return (
    <>
      {!isLoading ? (
        <>
          <Skeleton style={{height: '100%', width: '100%'}} />
        </>
      ) : (
        <>
          {isRequested ? (
            <div className='p-6 h-100 overflow-auto'>
              {!requestAccepted && !requestRejected && (
                <div className='w-100'>
                  <InfoCard2
                    title={formatMessage({id: 'Submit & Send Files Easily with RecordsKeeper'})}
                    desc={formatMessage({
                      id: `Submit the requested files quickly and easily through this page. Just upload your files and click 'Submit'. The request creator will be automatically notified once your submission is complete.`,
                    })}
                    slug='https://help.recordskeeper.ai/en/articles/10368517-how-to-submit-and-send-requested-files-on-recordskeeper-ai'
                    className='w-100 mb-0'
                  />
                  <div className='d-flex flex-column'>
                    <h2 className='mt-4 text-wrap lh-base'>{requestDetails.name}</h2>
                    <p className='m-0 w-100 text-wrap lh-base'>
                      <div dangerouslySetInnerHTML={{__html: requestDetails?.message}} />
                    </p>

                    {paramValue === 'accept' && !requestReject && (
                      <div className='d-flex flex-column justify-content-between h-100'>
                        <div className='my-6'>
                          <BasicButton
                            height='44px'
                            border='1px solid #4776E6'
                            color='#4776E6'
                            textColor='white'
                            padding='12px 24px'
                            onClick={() => {
                              setModalStatus(true)
                            }}
                            buttonText={formatMessage({id: 'Click to Upload'})}
                            minWidth={56}
                          />
                          <p className='text-muted m-0 mt-4'>
                            Word, PDF, Excel, Images, PPT are only allowed.
                            <br />
                            Maximum allowed file size is 100MB
                          </p>
                          <div className='mb-4 col-md-4'>
                            {files.length > 0 && (
                              <div className='d-flex form-label text-dark font-size-13 mt-4'>
                                {formatMessage({id: 'Uploaded Files'})}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Manage all uploaded files here.',
                                  })}
                                />
                              </div>
                            )}
                            <div className='w-100 mt-4'>
                              <ul
                                className='p-0 m-0 pb-4'
                                style={{overflowY: 'scroll', height: '200px'}}
                              >
                                {files.map((file, index) => (
                                  <li
                                    key={index}
                                    className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-4'
                                  >
                                    <div className='d-flex align-items-center gap-2'>
                                      <img src={getFileType(file.name)} alt='' />
                                      <p className='m-0 font-size-13'>{file.name}</p>
                                    </div>
                                    <button
                                      className='btn btn-secondry p-0 m-0'
                                      onClick={() => {
                                        setShowCancelModal(true)
                                        setId(index)
                                      }}
                                      type='button'
                                    >
                                      <img src={deleteIcon} alt='Delete' />
                                    </button>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          <FileUpload
                            fileSize={parseInt(
                              process.env.REACT_APP_RK_MAX_ZIP_FILE_SIZE as string
                            )}
                            maxFileNumber={10}
                            allowType={allowedRecordTypes}
                            metaData={{module: 'document', isProtected: false}}
                            modalStatus={modalStatus}
                            handleClose={() => {
                              setModalStatus(false)
                            }}
                            handleSuccess={(id: number, details: any) => {
                              setFiles((prevFiles: any) => [
                                ...prevFiles,
                                {id: id, details: details, name: details.path.split('/').pop()},
                              ])
                            }}
                            resourceType='all'
                            assemblyOption='rk-doc-upload'
                            isPublic={true}
                            company={parseInt(company)}
                          />
                        </div>

                        {/* footer button  */}
                        <div className='d-flex justify-content-end gap-2 position-absolute bottom-0 right-0 p-4'>
                          <BasicButton
                            height='44px'
                            border='1px'
                            textColor='#E2564C'
                            padding='12px 24px'
                            onClick={() => {
                              setRequestReject(true)
                            }}
                            buttonText={formatMessage({id: 'Reject Request'})}
                            minWidth={56}
                          />
                          <BasicButton
                            height='44px'
                            border='1px solid #4776E6'
                            color='#4776E6'
                            textColor='white'
                            padding='12px 24px'
                            onClick={() => {
                              handleSubmit()
                            }}
                            disabled={loading || files.length === 0}
                            buttonText={
                              loading
                                ? formatMessage({id: 'Please wait ...'})
                                : formatMessage({id: 'Submit'})
                            }
                            minWidth={56}
                          />
                        </div>
                      </div>
                    )}
                    {(paramValue === 'reject' || requestReject) && (
                      <>
                        <div className='col-12'>
                          <div className='d-flex align-items-center mb-4'>
                            <p className='font-size-13 m-0'>
                              {formatMessage({id: 'Reason for denied file request'})}
                            </p>
                            <ToolTipUI tooltipText='Reason for denied file request' />
                            <div />
                          </div>
                          <Quill quillText={reason} setQuillText={setReason} />
                        </div>
                        <div className='mt-7 d-flex flex-column justify-content-center align-items-end'>
                          <BasicButton
                            height='44px'
                            border='1px solid #4776E6'
                            color='#4776E6'
                            textColor='white'
                            padding='12px 24px'
                            onClick={() => {
                              onRejectSubmit()
                            }}
                            disabled={reason.length === 0 || loading}
                            buttonText={
                              loading
                                ? formatMessage({id: 'Please wait ...'})
                                : formatMessage({id: 'Submit'})
                            }
                            minWidth={56}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
              {requestAccepted && (
                <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                  <img src={greenTick} alt='banner' height={80} width={80} className='w-100 mb-8' />
                  <h2 className='text-center mb-4'>
                    {formatMessage({
                      id: `Files Uploaded Successfully!!!`,
                    })}
                  </h2>
                  <p className='text-center mb-4'>
                    {formatMessage({
                      id: `Your file has been uploaded successfully! You can now check files in RecordsKeeper.AI.`,
                    })}
                  </p>

                  <div className='d-flex justify-content-center align-items-center'>
                    <BasicButton
                      height='44px'
                      border='1px solid #4776E6'
                      color='#4776E6'
                      textColor='white'
                      padding='12px 24px'
                      onClick={() => {
                        window.open(registrationUrl, '_blank');
                      }}
                      buttonText={isRecordskeeper ? 'Try RecordsKeeper.AI' : 'Try Foundercrate'}
                      minWidth={56}
                    />
                  </div>
                </div>
              )}
              {requestRejected && (
                <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                  <img src={redCross} alt='banner' height={80} width={80} className='w-100 mb-8' />

                  <h2 className='text-center mb-4'>
                    {formatMessage({
                      id: `Request Rejected!`,
                    })}
                  </h2>
                  <p className='text-center mb-4'>
                    {formatMessage({
                      id: `You have successfully rejected the request for file ${data.name}. If you rejected by mistake or need assistance, kindly reach out to the request sender.`,
                    })}
                  </p>

                  <div className='d-flex justify-content-center align-items-center'>
                  <BasicButton
                      height='44px'
                      border='1px solid #4776E6'
                      color='#4776E6'
                      textColor='white'
                      padding='12px 24px'
                      onClick={() => {
                        window.open(registrationUrl, '_blank');
                      }}
                      buttonText={isRecordskeeper ? 'Try RecordsKeeper.AI' : 'Try Foundercrate'}
                      minWidth={56}
                    />
                  </div>
                </div>
              )}
              {/* {(requestAccepted || requestRejected) &&
                            <div className='d-flex justify-content-center align-items-center'>
                                <BasicButton
                                    height='44px'
                                    border='1px solid #4776E6'
                                    color='#4776E6'
                                    textColor='white'
                                    padding='12px 24px'
                                    onClick={() => {
                                        navigate('/auth/login')
                                    }}
                                    buttonText={formatMessage({ id: 'Try Foundercrate' })}
                                    minWidth={56}
                                />
                            </div>} */}
            </div>
          ) : (
            <div className='d-flex flex-column justify-content-center align-items-center h-100'>
              <img src={greenTick} alt='banner' height={80} width={80} className='w-100 mb-8' />
              <h2 className='text-center mb-4'>
                {formatMessage({
                  id: `Request File`,
                })}
              </h2>
              <p className='text-center mb-4'>
                {formatMessage({
                  id: `Your file request has been already completed.`,
                })}
              </p>

              <div className='d-flex justify-content-center align-items-center'>
              <BasicButton
                      height='44px'
                      border='1px solid #4776E6'
                      color='#4776E6'
                      textColor='white'
                      padding='12px 24px'
                      onClick={() => {
                        window.open(registrationUrl, '_blank');
                      }}
                      buttonText={isRecordskeeper ? 'Try RecordsKeeper.AI' : 'Try Foundercrate'}
                      minWidth={56}
                    />
              </div>
            </div>
          )}
        </>
      )}

      <DeleteFileConfirmationModal
        setDeleteShowModal={setShowCancelModal}
        showDeleteModal={showCancelModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={cancelLoading}
      />
    </>
  )
}

export default RecordKeeperPublicRequest
